import { useCallback, useState } from 'react';
import { isToday } from 'date-fns';
import {
  HOURS_OPTIONS,
  INITIAL_VALUES
} from '../../../../DataTableAdvancedElements/DataTableQuickReports/utils/QuickReports.constants';
import { FormCreateScheduleExport } from '../../../../DataTableAdvancedElements/DataTableQuickReports/utils/QuickReports.type';

export const useScheduleExportForm = (
  initialValues?: Partial<Pick<FormCreateScheduleExport, 'fileFormat' | 'startTimestamp' | 'timeInterval'>> | undefined
) => {
  const [scheduleExport, setScheduleExport] = useState<FormCreateScheduleExport>(getInitialValues(initialValues));
  const getQueryData = useCallback(() => {
    const { fileFormat, timeInterval, uid } = scheduleExport;
    const startTimestamp = scheduleExport.startTimestamp;
    if (startTimestamp) {
      startTimestamp.setHours(scheduleExport.hour ? +scheduleExport.hour : 0);
      startTimestamp.setMinutes(0);
    }
    return {
      fileFormat,
      timeInterval,
      startTimestamp: startTimestamp || undefined,
      uid,
      targetSftpDirectoryUid: scheduleExport.targetSftpDirectoryUid
    };
  }, [scheduleExport]);

  return { scheduleExport, setScheduleExport, getQueryData };
};

const getInitialValues = (
  initialValues?: Partial<Pick<FormCreateScheduleExport, 'fileFormat' | 'startTimestamp' | 'timeInterval'>> | undefined
): FormCreateScheduleExport => {
  const time = getAvailableTimeOptions(initialValues?.startTimestamp);

  return {
    ...INITIAL_VALUES,
    hour: time.timeStampHour ?? time.hoursOptions[0]?.value,
    ...initialValues
  };
};

export const getAvailableTimeOptions = (startTimestamp: Date | null | undefined) => {
  const today = new Date();
  const currentHour = today.getHours();
  const isTodaySelected = startTimestamp ? isToday(startTimestamp) : false;
  const tomorrow = today.setDate(today.getDate() + 1);
  const timeStampHour = startTimestamp && startTimestamp?.getHours()?.toString();

  return {
    timeStampHour,
    isTodaySelected,
    currentHour,
    hoursOptions: !isTodaySelected
      ? HOURS_OPTIONS
      : HOURS_OPTIONS.filter((hourOption) => +hourOption.value > currentHour),
    tomorrow
  };
};
